import type { Entry, Manifest } from "../lib/types";
import { CatalogueCard } from "./pages/CatalogueCard";
import { FieldPlate } from "./pages/FieldPlate";
import { HerbariumSheet } from "./pages/HerbariumSheet";

/** Every scrapbook template takes exactly this, and nothing else. */
export type ScrapbookTemplateProps = {
  entry: Entry;
  manifest: Manifest | undefined;
  /** Play the one-time reveal after classification lands. */
  revealing?: boolean;
  /** Presigned image URLs expire; refetch the entry to get a fresh one. */
  onImageError?: () => void;
};

export type ScrapbookPageProps = ScrapbookTemplateProps;

/**
 * Dispatch on `entry.variant`.
 *
 * The registry decides which template a find gets, so this is the only place
 * that maps a variant string to a layout — and anything unrecognised falls
 * through to the catalogue card rather than breaking the page.
 */
export function ScrapbookPage(props: ScrapbookPageProps) {
  switch (props.entry.variant) {
    case "herbarium":
      return <HerbariumSheet {...props} />;
    case "plate":
    case "specimen":
      return <FieldPlate {...props} />;
    case "elevation":
    case "label":
    case "card":
      return <CatalogueCard {...props} />;
    default:
      // A variant we've never heard of: still a real page, just a plainer one.
      return <CatalogueCard {...props} />;
  }
}
